import { Validator } from '@/Validator/index';

export class VuetifyValidateRule {
    static of<T>(validator: Validator<T>) {
        return (v: T) => validator.validate(v) || validator.ErrorMessage;
    }
}
